import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { MsalGuard } from '@azure/msal-angular';
import { OverageComponent } from './overage/overage.component';
import { PiPointComponent } from './pi-point/pi-point.component';
import { pihistoryDataComponent } from './pihistory-data/pihistory-data.component';
import { MonitorComponent } from './pipeline-configuration/monitor/monitor.component';
import { PipelineConfigurationComponent } from './pipeline-configuration/pipeline-configuration.component';
import { TagmasterComponent } from './tagmaster/tagmaster.component';
import { GroupGuardService } from './services/group-guard.service';
import { KpiFormulaBuilderComponent } from './kpiformulabuilder/kpiformulabuilder.component';
import { ViewFormulaComponent } from './kpiformulabuilder/viewFormula/viewFormula.component';
import { DataCleansingComponent } from './data-cleansing/data-cleansing.component';
import { RulesComponent } from './data-cleansing/rules/rules.component';
import { ConstantsComponent } from './kpiformulabuilder/constants/constants.component';
import { CreateFormulaModelComponent } from './kpiformulabuilder/create-formula-model/create-formula-model.component';
import { environment } from 'src/environments/environment';

let enValue = environment;

const routes: Routes = [
  {
    path: 'overage',
    component: OverageComponent,
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'DataPlatform',
    component: HomeComponent,
    canActivate: [
      MsalGuard,
      GroupGuardService
    ],
    data: {
      expectedGroups: [
        enValue.groups_client_PlatformAdminGroupId,
        enValue.groups_client_TagAdminGroupId,
        enValue.groups_client_FoundationUserGroupId
      ],
      breadcrumb: "Dashboard"
    },
    children: [
      {
        path: 'TagMaster',
        component: TagmasterComponent,
        data: {
          breadcrumb: "Overview"
        },
      },
      {
        path: 'PiPoint',
        component: PiPointComponent,
        data: {
          breadcrumb: "Overview"
        },
      },
      {
        path: 'Monitor',
        component: MonitorComponent,
        data: {
          breadcrumb: "Overview"
        },
      },
      {
        path: 'PipelineDetails',
        component: PipelineConfigurationComponent,
        data: {
          breadcrumb: "PipelineDetails"
        }
      },
      {
        path: 'PIHistoryData',
        component: pihistoryDataComponent,
        data: {
          breadcrumb: "History"
        }
      },
      {
        path: '**',
        redirectTo: 'TagMaster',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'FormulaBuilder',
    component: KpiFormulaBuilderComponent,
    canActivate: [
      MsalGuard,
      GroupGuardService
    ],
    data: {
      expectedGroups: [
        enValue.groups_client_PlatformAdminGroupId,
        enValue.groups_client_TagAdminGroupId,
        enValue.groups_client_FoundationUserGroupId
      ],
      breadcrumb: "Dashboard"
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'viewFormula'
      },
      {
        path: 'viewFormula',
        component: ViewFormulaComponent,
      },
      {
        path: 'createFormula',
        component: CreateFormulaModelComponent,
      },
      {
        path: 'constants',
        component: ConstantsComponent,
      }
    ]
  },
  {
    path: 'DataCleansing',
    component: DataCleansingComponent,
    canActivate: [
      MsalGuard,
      GroupGuardService
    ],
    data: {
      expectedGroups: [
        enValue.groups_client_PlatformAdminGroupId,
        enValue.groups_client_TagAdminGroupId,
        enValue.groups_client_FoundationUserGroupId
      ],
      breadcrumb: "Dashboard"
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'rules'
      },
      {
        path: 'rules',
        component: RulesComponent,
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'DataPlatform',
    pathMatch: 'full'
  }
];



@NgModule({
  imports: [RouterModule.forChild(routes), RouterModule.forRoot(routes, { useHash: false, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
